import React, { useEffect, useState } from "react";
import Headers from '../components/Headers'
import Footer from '../components/Footer'
import FlutterwavePayment from '../components/FlutterwavePayment'
import { useLocation } from 'react-router-dom'
import { formatCurrency } from "../utils/currencyUtils";
import { useCurrency } from "../hooks/useCurrency"
import { useDispatch, useSelector } from "react-redux";
const Payment = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { state: { price, items, orderId, customerName, customerPhone, paymentMethod, numInstallments } } = useLocation()
    const { currencyCode, exchangeLoaded } = useCurrency()

    const isInstallment = paymentMethod === 'installment' && numInstallments
    const firstInstallmentAmount = isInstallment
        ? Math.ceil((price / numInstallments) * 100) / 100
        : price

    return (
        <div>
            <Headers />
            <section>
                <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16'>
                    <div className='flex flex-wrap md:flex-col-reverse'>
                        <div className='w-full'>
                            <div className='pl-2 md:pl-0 md:mb-0'>
                                <div className='bg-white border border-gray-100 shadow-sm p-5 text-gray-900 flex flex-col gap-3'>
                                    <div className='flex items-center gap-3'>
                                        <h2>Order Summary</h2>
                                        {isInstallment && (
                                            <span className='text-xs bg-[#ffe11b] text-black font-semibold px-2 py-0.5 rounded-full'>
                                                Installment Plan — {numInstallments}x Monthly
                                            </span>
                                        )}
                                    </div>
                                    <div className='flex justify-between items-center'>
                                        <span>{items} items and shipping fee included</span>
                                        <span>{formatCurrency(price, currencyCode, exchangeLoaded)}</span>
                                    </div>
                                    {isInstallment ? (
                                        <>
                                            <div className='flex justify-between items-center text-sm text-gray-500'>
                                                <span>Total across {numInstallments} payments</span>
                                                <span>{formatCurrency(price, currencyCode, exchangeLoaded)}</span>
                                            </div>
                                            <div className='flex justify-between items-center font-semibold'>
                                                <span>Due Today (1st installment)</span>
                                                <span className='text-lg text-[#ffe11b]'>{formatCurrency(firstInstallmentAmount, currencyCode, exchangeLoaded)}</span>
                                            </div>
                                        </>
                                    ) : (
                                        <div className='flex justify-between items-center font-semibold'>
                                            <span>Total Amount</span>
                                            <span className='text-lg text-[#ffe11b]'>{formatCurrency(price, currencyCode, exchangeLoaded)}</span>
                                        </div>
                                    )}
                                    <FlutterwavePayment
                                        orderId={orderId}
                                        price={firstInstallmentAmount}
                                        customerName={customerName}
                                        customerPhone={customerPhone}
                                        paymentMethod={paymentMethod}
                                        numInstallments={numInstallments}
                                        currencyCode={currencyCode}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Payment